import { RopePositionsTexture } from "../basePass";
import { Shader } from "../core/shaderUtils";
import { GTexturePool } from "../core/texturePool";
import { GLBindUniformBuffer, GLSetTexture } from "../helpers/glHelper";
import { CommonRenderingResources } from "../shaders/shaderConfig";
import { ShaderSourceFullscreenPassVS } from "../shaders/shaderPostProcess";
import { GetShaderSourceSDFRenderPS, GetShaderSourceSDFVolumeLightRenderPS } from "../shaders/shaderSDF";
import { SceneBase } from "./scene";

export function GetSDFRenderUniformParametersList(gl: WebGL2RenderingContext, shaderProgram: WebGLProgram) {
    const params = {
        SceneUniformBuffer: gl.getUniformBlockIndex(shaderProgram, "SceneUniformBuffer"),
        ProjectorTexture: gl.getUniformLocation(shaderProgram, "ProjectorTexture"),
        BlueNoiseTexture: gl.getUniformLocation(shaderProgram, "BlueNoiseTexture"),
        SDFTexture: gl.getUniformLocation(shaderProgram, "SDFTexture"),
        SDFTexture2: gl.getUniformLocation(shaderProgram, "SDFTexture2"),
        RopePositionsTextureSDF: gl.getUniformLocation(shaderProgram, "RopePositionsTextureSDF"),

        CubemapTexture: gl.getUniformLocation(shaderProgram, "CubemapTexture"),
        TransitionParam: gl.getUniformLocation(shaderProgram, "TransitionParam"),
        ScreenRatio: gl.getUniformLocation(shaderProgram, "ScreenRatio"),
        ETVSwitchState: gl.getUniformLocation(shaderProgram, "ETVSwitchState"),
    };
    return params;
}

export class SDFRender {
    ShaderSDF;
    ShaderVolumeLight;

    BlueNoiseTexture;

    static GpSDFMeshTexture: WebGLTexture | null = null;
    static GpSDFMeshTexture2: WebGLTexture | null = null;

    constructor(gl: WebGL2RenderingContext, curSceneSDF: string) {
        this.ShaderSDF = new Shader(
            gl,
            ShaderSourceFullscreenPassVS,
            GetShaderSourceSDFRenderPS(curSceneSDF),
            GetSDFRenderUniformParametersList,
        );
        this.ShaderVolumeLight = new Shader(
            gl,
            ShaderSourceFullscreenPassVS,
            //GetShaderSourceDestrSceneVolumeLightRenderPS(curSceneSDF),
            GetShaderSourceSDFVolumeLightRenderPS(curSceneSDF),
            GetSDFRenderUniformParametersList,
        );

        this.BlueNoiseTexture = GTexturePool.CreateTexture(gl, false, "blueNoise_R8");

        gl.bindTexture(gl.TEXTURE_2D, this.BlueNoiseTexture);
        /* gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST); */

        //this.Texture3D = GSDFMeshGenerator.Generate(gl);
    }

    BindResources(gl: WebGL2RenderingContext, curShader: Shader) {
        GLBindUniformBuffer(
            gl,
            SceneBase.UniformBuffer.BufferGPU!,
            curShader.ShaderProgram,
            curShader.UniformParametersLocationList.SceneUniformBuffer,
        );

        let textureBindIndex = 1;
        if (SceneBase.GpCurProjectorTexture) {
            GLSetTexture(
                gl,
                curShader.UniformParametersLocationList.ProjectorTexture,
                SceneBase.GpCurProjectorTexture,
                //SceneBase.ProjectorTexture.InnerTexture,
                textureBindIndex++,
            );
        }

        GLSetTexture(
            gl,
            curShader.UniformParametersLocationList.BlueNoiseTexture,
            this.BlueNoiseTexture,
            textureBindIndex++,
        );

        if (RopePositionsTexture) {
            GLSetTexture(
                gl,
                curShader.UniformParametersLocationList.RopePositionsTextureSDF,
                RopePositionsTexture,
                textureBindIndex++,
            );
        }

        if (SDFRender.GpSDFMeshTexture) {
            textureBindIndex++;
            gl.activeTexture(gl.TEXTURE0 + textureBindIndex);
            gl.bindTexture(gl.TEXTURE_3D, SDFRender.GpSDFMeshTexture);
            gl.uniform1i(curShader.UniformParametersLocationList.SDFTexture, textureBindIndex);
        }
        if (SDFRender.GpSDFMeshTexture2) {
            textureBindIndex++;
            gl.activeTexture(gl.TEXTURE0 + textureBindIndex);
            gl.bindTexture(gl.TEXTURE_3D, SDFRender.GpSDFMeshTexture2);
            gl.uniform1i(curShader.UniformParametersLocationList.SDFTexture2, textureBindIndex);
        }
    }

    Render(gl: WebGL2RenderingContext) {
        gl.bindVertexArray(CommonRenderingResources.FullscreenPassVAO);
        gl.useProgram(this.ShaderSDF.ShaderProgram);

        this.BindResources(gl, this.ShaderSDF);

        gl.drawArrays(gl.TRIANGLES, 0, 3);
    }

    RenderVolumeLight(gl: WebGL2RenderingContext) {
        gl.bindVertexArray(CommonRenderingResources.FullscreenPassVAO);
        gl.useProgram(this.ShaderVolumeLight.ShaderProgram);

        this.BindResources(gl, this.ShaderVolumeLight);

        gl.drawArrays(gl.TRIANGLES, 0, 3);
    }
}
